import * as React from 'react';

import { cn } from '../lib/utils';

function Textarea({
	className,
	variant = 'default',
	...props
}: React.ComponentProps<'textarea'> & { variant?: 'default' | 'ghost' }) {
	return (
		<textarea
			data-slot="textarea"
			className={cn(
				'flex w-full resize-none bg-transparent text-base outline-none transition-[color,border-color,padding,box-shadow] md:text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
				variant === 'default' &&
					'border-input dark:bg-input/30 focus-visible:border-ring aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-input/50 dark:disabled:bg-input/80 field-sizing-content min-h-16 rounded-lg border px-2.5 py-2 aria-invalid:ring-3',
				variant === 'ghost' && 'field-sizing-content min-h-0 border-none p-0 shadow-none focus-visible:ring-0',
				className,
			)}
			{...props}
		/>
	);
}

export { Textarea };
